'use strict';
import React from 'react';
import ReactDom from 'react-dom';
import { Link } from 'react-router-dom';
import EstateList from './estateList';
import emAction from '../../actions/emAction';

class EstateBody extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleMouseScroll = this.handleMouseScroll.bind(this);
        this.state = {
            tableWidth: 300,
            page: 0,
            contentNo: 10,
        };
    }
    static defaultProps = {
        monthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };

    componentDidMount() {
        let tableWidth = ReactDom.findDOMNode(this.refs.est).clientWidth;
        this.setState({
            tableWidth: tableWidth
        });
        if (document.body.clientWidth > 768) {
            window.addEventListener('wheel', this.handleMouseScroll);
        }
        window.addEventListener('scroll', this.handleScroll);

    }
    componentWillUnmount() {
        if (document.body.clientWidth > 768) {
            window.removeEventListener('wheel', this.handleMouseScroll);
        }
        window.removeEventListener('scroll', this.handleScroll);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.estate != this.props.estate) {
            this.setState({
                page: 0
            });
        }
    }
    handleMouseScroll(e) {
        e.preventDefault();

        if (e.deltaY > 0) {
            //scroll down
            window.scrollBy(0, 50);
        } else {
            //scroll up
            window.scrollBy(0, -50);
        }

    }
    handleScroll(e) {
        let elem1 = ReactDom.findDOMNode(this.refs.est);
        let elem2 = ReactDom.findDOMNode(this.refs.table);
        if (elem2.getBoundingClientRect().top < 30) {

            elem1.style.position = "absolute";
            
            if (document.body.clientWidth > 768) {
                elem2.style.paddingTop ="50px";
                elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";

            } else {
                elem2.style.paddingTop ="0px";
                elem1.style.top = -elem2.getBoundingClientRect().top + "px";

            }
        } else {
            elem1.style.position = "relative";
            elem1.style.top = "0px";
            elem2.style.paddingTop ="0px";
        }

    }
    handleChange(e) {
        let value = parseInt(e.target.value);
        emAction.sortByStatus(value);
    }
    handleClick(e) {
        let index = parseInt(e.currentTarget.getAttribute('data-index'));
        if (index != this.state.page) {
            this.setState({ page: index });
        }
    }
    renderPagination() {
        if (!this.props.estate) return;
        if (this.props.estate.length == 0) return;

        let pageNo = Math.ceil(this.props.estate.length / this.state.contentNo);

        let pagination = [];
        for (let i = 0; i < pageNo; i++) {
            pagination = pagination.concat(
                <li className={this.state.page == i ? "active" : ""} key={i} data-index={i} onClick={this.handleClick}>
                    <a href="#" >{i + 1}</a>
                </li>
            );
        }
        return (
            <nav className="ctr-pg" style={{ maxWidth: this.state.tableWidth + "px" }}>

                <ul className="pagination">
                    {pagination}
                </ul>
                <div className="pagination-title">page {(this.state.page + 1) + " of " + pageNo}</div>
            </nav>
        )
    }
    render() {
        let year = this.props.selectedYear ? this.props.selectedYear : new Date().getFullYear();
        let month = this.props.selectedMonth ? this.props.selectedMonth : new Date().getMonth();

        let start_day = new Date(year, month, 1).getDay();
        let last_date = new Date(year, month + 1, 0).getDate();
        let last_wk = Math.ceil((last_date + start_day) / 7);

        let estate = [];
        for (let i = 0 + this.state.contentNo * this.state.page; i < this.state.contentNo + this.state.contentNo * this.state.page; i++) {
            if (i < this.props.estate.length) {
                estate = estate.concat(this.props.estate[i]);
            }
        }
        return (
            <div>
                <form className="form-horizontal em-sort" style={{ maxWidth: this.state.tableWidth + "px" }}>
                    <label htmlFor="sort" className="col-xs-4 control-label">Sort Status By:</label>
                    <div className="input-group input-group-sm">
                        <select className="form-control atd-sel" id="sort" name="sort" onChange={this.handleChange}>
                            <option value="" ></option>
                            <option value="1" >Not Ok</option>
                            <option value="2" >Resolved</option>
                            <option value="0" >Ok</option>
                        </select>
                    </div>
                </form>
                {this.renderPagination()}
                <div className="est-bd-wp" ref="table">
                    <div className="est-bd">
                        <table className="est-tb tb-heading" ref="est">
                            <thead>
                                <tr>
                                    <th>Estate</th>
                                    <th>MCST</th>
                                    <th>PE</th>
                                    <th>Date</th>
                                    <th>Day</th>
                                    <th>Time</th>
                                    <th>Area</th>
                                    <th>Category</th>
                                    <th>Status</th>
                                    <th>Incident Report</th>
                                </tr>
                            </thead>
                        </table>
                        <EstateList estate={estate} tableWidth={this.state.tableWidth}
                            page={this.state.page} contentNo={this.state.contentNo} />
                    </div>

                </div>
                {this.renderPagination()}
            </div>
        );
    }
}
export default EstateBody;


// WEBPACK FOOTER //
// ./app/components/emComponents/estateBody.js